export default {
  universalModalToggle(state) {
    state.universalModal = !state.universalModal
  },
  deleteModalToggle(state) {
    state.deleteModal = !state.deleteModal
  },
  clearObject(state, data) {
    Object.keys(data).forEach(i => {
      data[i] = "";
    })
  },
  handleToggleModal(state) {
    state.universalModal = true;
    state.id = null;
  },
  handleEditData(state, data) {
    state.id = data;
    state.universalModal = true;
  },
  handleDeleteData(state, data) {
    state.id = data;
    state.deleteModal = true;
  }
}